import { Outlet } from "react-router";
import { AppHeader } from "@/components/layout/app-header";
import { AppSidebar } from "@/components/layout/app-sidebar";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { useContextSync } from "@/features/canteiros/hooks/use-context-sync";

export function AppLayout() {
	useContextSync();

	return (
		<SidebarProvider className="app-shell">
			<AppHeader />
			<div className="app-shell__body">
				<AppSidebar />
				<SidebarInset>
					<div className="app-shell__content">
						<Outlet />
					</div>
				</SidebarInset>
			</div>
		</SidebarProvider>
	);
}
